/* Chantier jQuery defer (2026-08-01)
   Exécute la file d'attente nlxJQ dans l'ordre du DOM une fois jQuery (différé) chargé.
   Chaque callback est isolé par try/catch : une erreur n'interrompt pas les autres.
   Chargé en defer TOUT À LA FIN du body (après toutes les libs jQuery différées). */
(function () {
  function run(f) {
    try { f(window.jQuery); }
    catch (e) { if (window.console && console.error) console.error('nlxJQ:', e); }
  }
  var q = (window.nlxJQ && window.nlxJQ.q) || [];
  /* Les appels tardifs (scripts chargés dynamiquement) s'exécutent immédiatement. */
  window.nlxJQ = run;
  for (var i = 0; i < q.length; i++) run(q[i]);
})();
